import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-shopping-sort1-icon',
  templateUrl: './shopping-sort1.component.html'
})
export class ShoppingSort1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
